import { Badge, type BadgeTone } from '../../components';
import type { JobStatus } from '../../types/api';

/**
 * Como cada status é comunicado (SPEC-014 §9).
 *
 * `PARTIAL` é deliberadamente "aviso" e não "sucesso": mostrar tom verde faria
 * o usuário concluir que não há conteúdo na plataforma que falhou, quando na
 * verdade nem chegamos a olhar.
 */
const PRESENTATION: Record<JobStatus, { label: string; tone: BadgeTone }> = {
  PENDING: { label: 'Na fila', tone: 'neutral' },
  RUNNING: { label: 'Coletando…', tone: 'info' },
  // Não é sucesso nem falha: é a coleta parada esperando uma decisão que só
  // uma pessoa pode tomar (SPEC-005 RF-D06).
  AWAITING_SELECTION: { label: 'Aguardando sua escolha', tone: 'warning' },
  COMPLETED: { label: 'Concluída', tone: 'success' },
  PARTIAL: { label: 'Parcial', tone: 'warning' },
  FAILED: { label: 'Falhou', tone: 'danger' },
  CANCELLED: { label: 'Cancelada', tone: 'neutral' },
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  const { label, tone } = PRESENTATION[status];
  return <Badge tone={tone}>{label}</Badge>;
}

export function jobStatusLabel(status: JobStatus): string {
  return PRESENTATION[status].label;
}
